import { Navigate, Outlet } from "react-router-dom";
import { isTokenValid } from "./utils/tokenValidation";
import { routes } from "./routes";

const ProtectedRouteAuthenticated = ({ redirectTo = routes.dashboard }: { redirectTo?: string }) => {
  const isAuthenticated = isTokenValid();
  if (isAuthenticated) {
    return <Navigate to={redirectTo} />;
  }
  return <Outlet />;
};

export default ProtectedRouteAuthenticated;